module.exports = "<div ng-if=\"plotlyOptions.globalSeriesType != 'custom'\">\n  <plotly-chart options=\"plotlyOptions\" series=\"chartSeries\"></plotly-chart>\n</div>\n<div ng-if=\"plotlyOptions.globalSeriesType == 'custom'\">\n  <custom-plotly-chart series=\"chartSeries\" options=\"plotlyOptions\"></custom-plotly-chart>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/visualizations/chart/chart.html
// module id = 508
// module chunks = 1